import { render } from "./CoursesParent.vue?vue&type=template&id=365067fa&scoped=true"
import script from "./CoursesParent.vue?vue&type=script&lang=js"
export * from "./CoursesParent.vue?vue&type=script&lang=js"

import "./CoursesParent.vue?vue&type=style&index=0&id=365067fa&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-365067fa"]])

export default __exports__